export default "__VITE_ASSET__9241a6d3__"